import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/data",
    name: "data",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Data.vue"),
  },
  {
    path: "/report",
    name: "report",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Report.vue"),
  },
  {
    path: "/download",
    name: "download",
    component: () =>
      import(/* webpackChunkName: "download" */ "../views/Download.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
